<template>
  <div class="previewselectcuration-wrap">
    <a tabindex="0" class="cursor">
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="onClickDetailModal"
      >
        <path
          d="M18.636 16.828L13.686 21.778L12.272 20.364L18.636 14L25 20.364L23.586 21.778L18.636 16.828Z"
          fill="white"
        />
      </svg>
    </a>
    <div
      class="curation-infobox"
      v-for="(item, index) in getList"
      :class="{ first: index === 0 }"
      :key="'curationItem' + index"
      :style="{ zIndex: getList.length - index }"
    >
      <!-- 장르 -->
      <img
        v-if="item.type === 'genre'"
        class="target-img"
        :src="getGenreImg(item.value)"
        :alt="item.value"
        :style="{ zIndex: getList.length - index }"
      />
      <!-- 국가 비율 -->
      <img
        v-if="item.type === 'country'"
        class="target-img"
        :src="getCountryImg(item.value)"
        :alt="item.value"
        :style="{ zIndex: getList.length - index }"
      />
      <!-- 타겟 -->
      <img
        v-if="item.type === 'target'"
        class="target-img"
        :src="getTargetImg(item.value)"
        :alt="item.value"
        :style="{ zIndex: getList.length - index }"
      />
      <!-- 소재 -->
      <div v-if="item.type === 'material'" class="curation-material" :style="{ zIndex: getList.length - index }">
        {{ item.value }}
      </div>
      <!-- 색상 -->
      <img
        v-if="item.type === 'color'"
        class="curation-color"
        :src="getColorImg"
        :alt="color"
        :style="{ zIndex: getList.length - index }"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // 색상
    color: {
      type: String,
      default: null
    },
    // 소재
    material: {
      type: Array,
      default: () => {
        return [];
      },
      required: false
    },
    // 타겟
    target: {
      type: Array,
      default: () => {
        return [];
      },
      required: false
    },
    // 국내곡비율
    country: {
      type: Number,
      default: -1,
      required: false
    },
    // 장르
    genre: {
      type: Array,
      default: () => {
        return [];
      },
      required: false
    },
    // 선택된 키값
    selectkey: {
      type: Array,
      default: () => {
        return [];
      },
      required: false
    }
  },
  data() {
    return {};
  },
  emits: ['click-detailmodal'],
  methods: {
    onClickDetailModal() {
      this.$emit('click-detailmodal');
    },
    isShowColumn(key) {
      if (this.selectkey.includes(key)) {
        return true;
      }
      return false;
    },
    getGenreImg(key) {
      const findGenre = this.$store.getters['curation/getGenreAll'].find(genre => genre.koText === key);
      if (findGenre) {
        return findGenre.imgUrl;
      }
    },
    getCountryImg(key) {
      let imgUrl = '';
      switch (key) {
        case 0:
          imgUrl = '/media/img/curation/img_per0.svg';
          break;
        case 10:
          imgUrl = '/media/img/curation/img_per10.svg';
          break;
        case 20:
          imgUrl = '/media/img/curation/img_per20.svg';
          break;
        case 30:
          imgUrl = '/media/img/curation/img_per30.svg';
          break;
        case 40:
          imgUrl = '/media/img/curation/img_per40.svg';
          break;
        case 50:
          imgUrl = '/media/img/curation/img_per50.svg';
          break;
        case 60:
          imgUrl = '/media/img/curation/img_per60.svg';
          break;
        case 70:
          imgUrl = '/media/img/curation/img_per70.svg';
          break;
        case 80:
          imgUrl = '/media/img/curation/img_per80.svg';
          break;
        default:
          break;
      }
      return imgUrl;
    },
    getTargetImg(key) {
      let imgUrl = '';
      switch (key) {
        case '유아/아동':
          imgUrl = 'media/img/unsplash_XIFuymJydII.png';
          break;
        case '청소년':
          imgUrl = 'media/img/image 1715.png';
          break;
        case '청년':
          imgUrl = 'media/img/unsplash_yk-CgvlrK1g.png';
          break;
        case '중장년':
          imgUrl = 'media/img/unsplash_6anudmpILw4.png';
          break;
        case '노년':
          imgUrl = 'media/img/unsplash_yRmmm3t1oX8.png';
          break;
        default:
          break;
      }
      return imgUrl;
    }
  },
  computed: {
    getColorImg() {
      const findImg = this.$store.getters['curation/getColorItemV2'](this.color);
      if (findImg) {
        return findImg.url;
      }
      return null;
    },
    getList() {
      const curationList = [];
      // 장르
      if (this.genre.length > 0 && this.isShowColumn('genre')) {
        this.genre.forEach(item => {
          curationList.push({
            type: 'genre',
            value: item
          });
        });
      }
      // 국내곡비율
      if (this.country > -1 && this.isShowColumn('country')) {
        curationList.push({
          type: 'country',
          value: this.country
        });
      }
      // 타겟
      if (this.target.length > 0 && this.isShowColumn('target')) {
        this.target.forEach(item => {
          curationList.push({
            type: 'target',
            value: item
          });
        });
      }

      // 소재
      if (this.material.length > 0 && this.isShowColumn('material')) {
        this.material.forEach(item => {
          curationList.push({
            type: 'material',
            value: item
          });
        });
      }
      // 색상
      if (this.color && this.isShowColumn('color')) {
        curationList.push({
          type: 'color',
          value: this.color
        });
      }

      return curationList;
    }
  }
};
</script>
<style scoped src="@/assets/css/building/previewselectcuration.css"></style>
